import React from 'react'
import Grid from '@material-ui/core/Grid'
import MenuList from '@material-ui/core/MenuList'
import withStyles from '@material-ui/core/styles/withStyles'
import { TitleGrid, PuzzleListCard } from '../../../containers'
import { PuzzleMenuItems } from '../containers'

const styles = theme => ({
})

class PuzzleHome extends React.Component {  
  render() {
    const { theme, windowWidth } = this.props
    var gridProp, titleGridProp
    gridProp = windowWidth < theme.breakpoints.values.md ? { xs: 12 } : { xs: 9 }
    titleGridProp = windowWidth < theme.breakpoints.values.md ? { menuItems : (<PuzzleMenuItems/>) } : undefined

    return (
      <div>
        <TitleGrid titleType='puzzle' {...titleGridProp}>
          {windowWidth >= theme.breakpoints.values.md && (
            <Grid item xs={12} md={3}>
              <MenuList>
                <PuzzleMenuItems/>
              </MenuList>
            </Grid>
          )}
          <Grid item {...gridProp}>
            <PuzzleListCard url='/puzzle'/>
          </Grid>
        </TitleGrid>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(PuzzleHome)



// WEBPACK FOOTER //
// ./src/Pages/Puzzle/components/PuzzleHome.js